var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { staticClass: "flow" }, [
    _c(
      "ul",
      { staticClass: "steps-desktop" },
      _vm._l(_vm.stepsData, function(step, index) {
        return _c(
          "li",
          { key: index, class: { active: index == _vm.activeStep } },
          [_vm._v("\n      " + _vm._s(step) + "\n    ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "steps-mobile" }, [
      _c("p", { staticClass: "title" }, [
        _vm._v("\n      " + _vm._s(_vm.stepsData[_vm.activeStep]) + "\n    ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "count" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.translation.step) +
            " " +
            _vm._s(_vm.activeStep + 1) +
            " /\n      " +
            _vm._s(_vm.stepsData.length) +
            "\n    "
        )
      ])
    ]),
    _vm._v(" "),
    !_vm.success ? _c("p", [_vm._v(_vm._s(_vm.text_top))]) : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("input", {
        attrs: {
          type: "hidden",
          id: "gclid_field",
          name: "gclid_field",
          value: ""
        }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", id: "cid_field", name: "cid", value: "" }
      }),
      _vm._v(" "),
      !_vm.success
        ? _c(
            "div",
            { class: _vm.type },
            [
              _c("transition", { attrs: { name: "slide", mode: "out-in" } }, [
                _vm.activeStep === 0
                  ? _c(
                      "div",
                      { key: "0", staticClass: "step" },
                      [
                        _vm._t("step-0"),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.next("form-1")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translation.next) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeStep === 1
                  ? _c(
                      "div",
                      { key: "1", staticClass: "step" },
                      [
                        _vm._t("step-1"),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.prev()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translation.prev) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.next("form-2")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translation.next) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeStep === 2
                  ? _c(
                      "div",
                      { key: "2", staticClass: "step" },
                      [
                        _vm._t("step-2"),
                        _vm._v(" "),
                        _c("div", { staticClass: "terms" }, [
                          _c("div", { staticClass: "checkbox-wrapper" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.agreed_terms.status,
                                  expression: "agreed_terms.status"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                name: "conditions",
                                id: "flow-conditions"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.agreed_terms.status)
                                  ? _vm._i(_vm.agreed_terms.status, null) > -1
                                  : _vm.agreed_terms.status
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.agreed_terms.status,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.agreed_terms,
                                          "status",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.agreed_terms,
                                          "status",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.agreed_terms, "status", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              { attrs: { href: _vm.terms, target: "_blank" } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(this.$translations.cart.terms_text) +
                                    "\n              "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.agreed_terms.error
                            ? _c("div", { staticClass: "form-error" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      this.$translations.cart.terms_error
                                    ) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.prev()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translation.prev) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            class: [
                              "btn-submit",
                              _vm.type,
                              { "btn-loading": _vm.loading }
                            ],
                            attrs: { type: "submit" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.submit()
                              }
                            }
                          },
                          [
                            _vm.loading
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.translation.sending) + "..."
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.translation.send))
                                ])
                          ]
                        )
                      ],
                      2
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.success
        ? _c("div", { staticClass: "form-success" }, [
            _c("p", { staticClass: "title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(this.$translations.form.post_success_one) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(this.$translations.form.post_success_two) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "icon" }, [
              _c("div", [
                _c(
                  "svg",
                  {
                    staticClass: "svg-inline--fa fa-check-circle fa-w-16",
                    attrs: {
                      "aria-hidden": "true",
                      focusable: "false",
                      "data-prefix": "far",
                      "data-icon": "check-circle",
                      role: "img",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 512 512"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "currentColor",
                        d:
                          "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                      }
                    })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "reset",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.reset()
                  }
                }
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.translation.reset) + "\n      "
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.error,
              expression: "error"
            }
          ],
          staticClass: "form-error"
        },
        [_vm._v("\n      " + _vm._s(_vm.translation.error_general) + "\n    ")]
      )
    ]),
    _vm._v(" "),
    !_vm.success ? _c("p", [_vm._v(_vm._s(_vm.text_bottom))]) : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }